import { render, staticRenderFns } from "./orderDetailDrawer.vue?vue&type=template&id=2f1f3ac4&scoped=true"
import script from "./orderDetailDrawer.vue?vue&type=script&lang=js"
export * from "./orderDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./orderDetailDrawer.vue?vue&type=style&index=0&id=2f1f3ac4&prod&lang=less&scoped=true"
import style1 from "./orderDetailDrawer.vue?vue&type=style&index=1&id=2f1f3ac4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f3ac4",
  null
  
)

export default component.exports